// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_int32 = require("rescript/lib/js/caml_int32.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var Nps$ReactHooksTemplate = require("./Nps.res.js");
var Csat$ReactHooksTemplate = require("./csat.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Logic$ReactHooksTemplate = require("./Logic.res.js");
var Action$ReactHooksTemplate = require("./Action.res.js");
var Survey$ReactHooksTemplate = require("./survey.res.js");
var Loading$ReactHooksTemplate = require("../dashboard/dashboard/Loading.res.js");
var Welcome$ReactHooksTemplate = require("./Welcome.res.js");
var DropDown$ReactHooksTemplate = require("./DropDown.res.js");
var LongText$ReactHooksTemplate = require("./LongText.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");
var ThankYou$ReactHooksTemplate = require("./ThankYou.res.js");
var ShortText$ReactHooksTemplate = require("./ShortText.res.js");
var LogicGraph$ReactHooksTemplate = require("./LogicGraph.res.js");
var StarRating$ReactHooksTemplate = require("./StarRating.res.js");
var AutoAdvance$ReactHooksTemplate = require("../general_settings/autoAdvance.res.js");
var LogicalJump$ReactHooksTemplate = require("./LogicalJump.res.js");
var RatingGroup$ReactHooksTemplate = require("./RatingGroup.res.js");
var SurveyLogic$ReactHooksTemplate = require("./SurveyLogic.res.js");
var OpinionScale$ReactHooksTemplate = require("./OpinionScale.res.js");
var SmileyRating$ReactHooksTemplate = require("./smileyRating.res.js");
var DateCondition$ReactHooksTemplate = require("./DateCondition.res.js");
var ListCondition$ReactHooksTemplate = require("./ListCondition.res.js");
var LogicCondition$ReactHooksTemplate = require("./LogicCondition.res.js");
var MultipleChoice$ReactHooksTemplate = require("./MultipleChoice.res.js");
var MultipleSelect$ReactHooksTemplate = require("./MultipleSelect.res.js");
var RedirectionUrl$ReactHooksTemplate = require("./redirectionUrl.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var NumberCondition$ReactHooksTemplate = require("./NumberCondition.res.js");
var StringCondition$ReactHooksTemplate = require("./StringCondition.res.js");
var SurveyNavigator$ReactHooksTemplate = require("./surveyNavigator.res.js");
var OpinionScaleLabel$ReactHooksTemplate = require("./OpinionScaleLabel.res.js");
var ApplicationSetting$ReactHooksTemplate = require("../general_settings/applicationSetting.res.js");
var PaginationPolicies$ReactHooksTemplate = require("../general_settings/paginationPolicies.res.js");
var ApplicationSettings$ReactHooksTemplate = require("../general_settings/applicationSettings.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");
var SurveyPreviewHtmlRenderer$ReactHooksTemplate = require("./SurveyPreviewHtmlRenderer.res.js");

var defaultQuestiontemplate = "\n  <div class=\"survey-response-page h-full min-h-screen\">\n    <div class=\"max-w-840-px mx-auto px-40-px small:px-20-px pt-32-px small:pt-0\n    small:pb-80-px\">\n      <div class=\"py-16-px\">\n        <div id=\"logo\">\n          logo\n        </div>\n      </div>\n      <div class=\"survey-question-area pt-24-px small:pt-16-px pb-54-px\"\n      style=\"min-height: calc(100vh - 294px);\">\n        <div id=\"question\">question</div>\n      </div>\n    </div>\n    <div class=\"survey-action-bar w-full bg-white small:bg-opacity-75\">\n      <div class=\"flex w-full max-w-840-px mx-auto px-40-px small:px-20-px small:pt-16-px items-center gap-4 pb-100-px\">\n        <div id=\"previousButton\"></div>\n        <div id=\"nextButton\"></div>\n      </div>\n    </div>\n  </div>\n";

var bhimaQuestiontemplate = "\n  <div class=\"h-full\">\n    <div class=\"pt-40-px w-full pb-20-px absolute\">\n    </div>\n    <div class=\"max-w-840-px mx-auto px-60-px small:px-20-px min-h-screen flex flex-col\n    justify-center pt-160-px small:pt-142-px pb-30-px\">\n      <div id=\"logo\">\n        logo\n      </div>\n      <div class=\"pb-100-px pt-5\">\n        <div id=\"question\">question</div>\n      </div>\n      <div class=\"flex w-full justify-center items-center gap-4 mb-8\">\n        <div id=\"previousButton\"></div>\n        <div id=\"nextButton\"></div>\n      </div>\n    </div>\n  </div>\n";

var questionTemplates = {
  bhima: bhimaQuestiontemplate,
  default: defaultQuestiontemplate
};

function questionsOrPageToString(x) {
  switch (x) {
    case "Welcome" :
        return "welcome";
    case "ThankYou" :
        return "thank_you";
    case "LongText" :
        return "LongText";
    case "ShortText" :
        return "ShortText";
    case "StarRating" :
        return "StarRating";
    case "OpinionScale" :
        return "OpinionScale";
    case "Nps" :
        return "Nps";
    case "MultipleChoice" :
        return "MultipleChoice";
    case "RatingGroup" :
        return "RatingGroup";
    case "SmileyRating" :
        return "Csat";
    case "MultipleSelect" :
        return "MultipleSelect";
    case "DropDown" :
        return "DropDown";
    case "MobileNumber" :
        return "MobileNumber";
    
  }
}

function surveyToJson(welcome, questions, thankYou, logicalJumpGroup) {
  return Json_encode.object_({
              hd: [
                "welcome",
                Belt_Option.mapWithDefault(welcome, null, (function (x) {
                        return Welcome$ReactHooksTemplate.toJson(undefined, x);
                      }))
              ],
              tl: {
                hd: [
                  "questions",
                  Belt_List.toArray(Belt_List.mapWithIndex(questions, (function (i, q) {
                              return Question$ReactHooksTemplate.toJson(undefined, i + 1 | 0, undefined, q);
                            })))
                ],
                tl: {
                  hd: [
                    "thank_you",
                    Belt_Option.mapWithDefault(thankYou, null, (function (x) {
                            return ThankYou$ReactHooksTemplate.toJson(undefined, 1, x);
                          }))
                  ],
                  tl: {
                    hd: [
                      "logic_jump",
                      LogicalJump$ReactHooksTemplate.encodeGroup(logicalJumpGroup)
                    ],
                    tl: /* [] */0
                  }
                }
              }
            });
}

function addQuestionsToGraph(questions, path) {
  return LogicGraph$ReactHooksTemplate.setPath(path, List.fold_left((function (graph, item) {
                    return LogicGraph$ReactHooksTemplate.addNode({
                                TAG: "Question",
                                _0: item
                              }, graph);
                  }), LogicGraph$ReactHooksTemplate.empty(), questions));
}

function surveyAnswers(questions) {
  return $$Array.of_list(Belt_List.mapWithIndex(questions, (function (i, q) {
                    return Question$ReactHooksTemplate.toJson(true, i + 1 | 0, undefined, q);
                  })));
}

function calculateTotalPages(survey) {
  var match = Survey$ReactHooksTemplate.paginationSettings(survey);
  if (match === undefined) {
    return List.length(survey.questions);
  }
  if (typeof match !== "object") {
    if (match === "SinglePage") {
      return 1;
    }
    var mappings = survey.pageMappings;
    if (mappings === undefined) {
      return 1;
    }
    var totalMappedPages = List.length(mappings);
    var unmappedQuestionsCount = List.length(Belt_List.keep(survey.questions, (function (q) {
                var p = Question$ReactHooksTemplate.position(q);
                var position = p !== undefined ? p : 0;
                return !Belt_List.some(mappings, (function (mapping) {
                              if (position >= mapping.fromQuestion) {
                                return position <= mapping.toQuestion;
                              } else {
                                return false;
                              }
                            }));
              })));
    return totalMappedPages + unmappedQuestionsCount | 0;
  } else {
    var perPage = match._0;
    var totalQuestions = List.length(survey.questions);
    return Caml_int32.div(totalQuestions, perPage) + (
            Caml_int32.mod_(totalQuestions, perPage) > 0 ? 1 : 0
          ) | 0;
  }
}

function getQuestionsForCurrentPage(survey, currentPage) {
  var multiplePageEnforced = List.exists((function (x) {
          var policy = ApplicationSetting$ReactHooksTemplate.individualSetting(x);
          if (policy.TAG === "PaginationPolicies" && ApplicationSetting$ReactHooksTemplate.enforced(x)) {
            return PaginationPolicies$ReactHooksTemplate.value(policy._0) === "MultiplePageSurvey";
          } else {
            return false;
          }
        }), Survey$ReactHooksTemplate.applicationSettings(survey));
  var enforcedSurvey;
  if (multiplePageEnforced && Caml_obj.equal(survey.paginationSettings, "SinglePage")) {
    var newrecord = Caml_obj.obj_dup(survey);
    newrecord.paginationSettings = {
      TAG: "Uniform",
      _0: 1
    };
    enforcedSurvey = newrecord;
  } else {
    enforcedSurvey = survey;
  }
  var match = Survey$ReactHooksTemplate.paginationSettings(enforcedSurvey);
  if (match !== undefined) {
    if (typeof match !== "object") {
      if (match === "SinglePage") {
        return enforcedSurvey.questions;
      }
      var mappings = survey.pageMappings;
      if (mappings === undefined) {
        return enforcedSurvey.questions;
      }
      var mapping = Belt_List.getBy(mappings, (function (x) {
              return x.page === currentPage;
            }));
      if (mapping !== undefined) {
        var toQuestion = mapping.toQuestion;
        var fromQuestion = mapping.fromQuestion;
        return Belt_List.keep(enforcedSurvey.questions, (function (q) {
                      var p = Question$ReactHooksTemplate.position(q);
                      var position = p !== undefined ? p : 0;
                      if (position >= fromQuestion) {
                        return position <= toQuestion;
                      } else {
                        return false;
                      }
                    }));
      }
      var unmappedQuestions = Belt_List.keep(enforcedSurvey.questions, (function (q) {
              var p = Question$ReactHooksTemplate.position(q);
              var pos = p !== undefined ? p : 0;
              return !Belt_List.some(mappings, (function (mapping) {
                            if (pos >= mapping.fromQuestion) {
                              return pos <= mapping.toQuestion;
                            } else {
                              return false;
                            }
                          }));
            }));
      var totalMappedPages = List.length(mappings);
      if (currentPage <= totalMappedPages) {
        return /* [] */0;
      }
      var unmappedPageIndex = (currentPage - totalMappedPages | 0) - 1 | 0;
      var question = Belt_List.get(unmappedQuestions, unmappedPageIndex);
      if (question !== undefined) {
        return {
                hd: question,
                tl: /* [] */0
              };
      } else {
        return /* [] */0;
      }
    } else {
      var perPage = match._0;
      var start = Math.imul(currentPage - 1 | 0, perPage);
      var totalQuestions = List.length(enforcedSurvey.questions);
      var questionsLeft = totalQuestions - start | 0;
      var count = questionsLeft < perPage ? questionsLeft : perPage;
      return Belt_Option.getWithDefault(Belt_List.take(Belt_Option.getWithDefault(Belt_List.drop(enforcedSurvey.questions, start), /* [] */0), count), /* [] */0);
    }
  } else {
    var start$1 = currentPage - 1 | 0;
    return Belt_Option.getWithDefault(Belt_List.take(Belt_Option.getWithDefault(Belt_List.drop(survey.questions, start$1), /* [] */0), 1), /* [] */0);
  }
}

function getQuestionView(survey, currentPage, singlePage) {
  var multiplePageEnforced = List.exists((function (x) {
          var policy = ApplicationSetting$ReactHooksTemplate.individualSetting(x);
          if (policy.TAG === "PaginationPolicies" && ApplicationSetting$ReactHooksTemplate.enforced(x)) {
            return PaginationPolicies$ReactHooksTemplate.value(policy._0) === "MultiplePageSurvey";
          } else {
            return false;
          }
        }), Survey$ReactHooksTemplate.applicationSettings(survey));
  var match = survey.paginationSettings;
  if (singlePage) {
    return {
            TAG: "MultipleQuestions",
            _0: survey.questions
          };
  }
  if (match !== undefined) {
    if (typeof match !== "object" && match === "SinglePage") {
      if (!multiplePageEnforced) {
        return {
                TAG: "MultipleQuestions",
                _0: survey.questions
              };
      }
      var questionsForPage = getQuestionsForCurrentPage(survey, currentPage);
      var q = Belt_List.head(questionsForPage);
      if (q !== undefined) {
        return {
                TAG: "SingleQuestion",
                _0: q
              };
      } else {
        return {
                TAG: "SingleQuestion",
                _0: undefined
              };
      }
    }
    
  } else {
    var questionsForPage$1 = getQuestionsForCurrentPage(survey, currentPage);
    var q$1 = Belt_List.head(questionsForPage$1);
    if (q$1 !== undefined) {
      return {
              TAG: "SingleQuestion",
              _0: q$1
            };
    } else {
      return {
              TAG: "SingleQuestion",
              _0: undefined
            };
    }
  }
  var questionsForPage$2 = getQuestionsForCurrentPage(survey, currentPage);
  return {
          TAG: "MultipleQuestions",
          _0: questionsForPage$2
        };
}

function getNextNode(state, node) {
  if (!state.embeddedLogic) {
    return SurveyNavigator$ReactHooksTemplate.nextNode(node, state.surveyNavigator);
  }
  switch (node.TAG) {
    case "Welcome" :
        return SurveyNavigator$ReactHooksTemplate.nextNode(node, state.surveyNavigator);
    case "ThankYou" :
        return ;
    case "Question" :
        var match = LogicGraph$ReactHooksTemplate.getNextNode(node._0, state.graph);
        if (match !== undefined) {
          if (match.TAG === "ThankYou") {
            return {
                    TAG: "ThankYou",
                    _0: match._0
                  };
          } else {
            return {
                    TAG: "Question",
                    _0: match._0
                  };
          }
        } else {
          return Belt_Option.mapWithDefault(SurveyNavigator$ReactHooksTemplate.thankYou(state.surveyNavigator), undefined, (function (x) {
                        return {
                                TAG: "ThankYou",
                                _0: x
                              };
                      }));
        }
    
  }
}

function getPreviousNode(state, node) {
  if (!state.embeddedLogic) {
    return SurveyNavigator$ReactHooksTemplate.previousNode(node, state.surveyNavigator);
  }
  switch (node.TAG) {
    case "Welcome" :
    case "ThankYou" :
        return ;
    case "Question" :
        var match = LogicGraph$ReactHooksTemplate.getPrevNode(node._0, state.graph);
        if (match !== undefined && match.TAG !== "ThankYou") {
          return {
                  TAG: "Question",
                  _0: match._0
                };
        } else {
          return ;
        }
    
  }
}

function findMatchingRedirectionUrlId(state, survey) {
  var logics = Survey$ReactHooksTemplate.redirectionLogics(survey);
  var sortLogicsByPriority = function (logics) {
    return Belt_List.sort(logics, (function (a, b) {
                  var priorityA = Logic$ReactHooksTemplate.priority(a);
                  var priorityB = Logic$ReactHooksTemplate.priority(b);
                  return priorityB - priorityA | 0;
                }));
  };
  var sortedLogics = sortLogicsByPriority(logics);
  var findTrueConditionLogic = Belt_List.getBy(sortedLogics, (function (logic) {
          var questions = state.embeddedLogic ? LogicGraph$ReactHooksTemplate.path(state.graph) : Belt_List.keepMap(SurveyNavigator$ReactHooksTemplate.path(state.surveyNavigator), (function (node) {
                    switch (node.TAG) {
                      case "Welcome" :
                      case "ThankYou" :
                          return ;
                      case "Question" :
                          return node._0;
                      
                    }
                  }));
          return !Belt_List.some(Logic$ReactHooksTemplate.conditions(logic), (function (cond) {
                        var q = LogicCondition$ReactHooksTemplate.lhs(cond);
                        if (q.TAG === "Question") {
                          var q$1 = q._0;
                          var surveyQuestion = Belt_List.getBy(questions, (function (question) {
                                  return Question$ReactHooksTemplate.equals(q$1, question);
                                }));
                          if (surveyQuestion === undefined) {
                            return true;
                          }
                          if (!Question$ReactHooksTemplate.answered(surveyQuestion)) {
                            return true;
                          }
                          var n = LogicCondition$ReactHooksTemplate.conditionType(cond);
                          var tmp;
                          switch (n.TAG) {
                            case "NumberCondition" :
                                tmp = NumberCondition$ReactHooksTemplate.evaluate(NumberCondition$ReactHooksTemplate.setLhs(n._0, {
                                          TAG: "Question",
                                          _0: surveyQuestion
                                        }));
                                break;
                            case "StringCondition" :
                                tmp = StringCondition$ReactHooksTemplate.evaluate(StringCondition$ReactHooksTemplate.setLhs(n._0, {
                                          TAG: "Question",
                                          _0: surveyQuestion
                                        }));
                                break;
                            case "ListCondition" :
                                tmp = ListCondition$ReactHooksTemplate.evaluate(ListCondition$ReactHooksTemplate.setLhs(n._0, {
                                          TAG: "Question",
                                          _0: surveyQuestion
                                        }));
                                break;
                            case "DateCondition" :
                                tmp = DateCondition$ReactHooksTemplate.evaluate(DateCondition$ReactHooksTemplate.setLhs(n._0, {
                                          TAG: "Question",
                                          _0: surveyQuestion
                                        }));
                                break;
                            
                          }
                          return tmp === false;
                        }
                        var d = q._0;
                        var n$1 = LogicCondition$ReactHooksTemplate.conditionType(cond);
                        var tmp$1;
                        switch (n$1.TAG) {
                          case "NumberCondition" :
                              tmp$1 = NumberCondition$ReactHooksTemplate.evaluate(NumberCondition$ReactHooksTemplate.setLhs(n$1._0, {
                                        TAG: "DataField",
                                        _0: d
                                      }));
                              break;
                          case "StringCondition" :
                              tmp$1 = StringCondition$ReactHooksTemplate.evaluate(StringCondition$ReactHooksTemplate.setLhs(n$1._0, {
                                        TAG: "DataField",
                                        _0: d
                                      }));
                              break;
                          case "ListCondition" :
                              tmp$1 = ListCondition$ReactHooksTemplate.evaluate(ListCondition$ReactHooksTemplate.setLhs(n$1._0, {
                                        TAG: "DataField",
                                        _0: d
                                      }));
                              break;
                          case "DateCondition" :
                              tmp$1 = DateCondition$ReactHooksTemplate.evaluate(DateCondition$ReactHooksTemplate.setLhs(n$1._0, {
                                        TAG: "DataField",
                                        _0: d
                                      }));
                              break;
                          
                        }
                        return tmp$1 === false;
                      }));
        }));
  if (findTrueConditionLogic === undefined) {
    return ;
  }
  var redirectionLogic = Belt_List.getBy(Logic$ReactHooksTemplate.actions(Caml_option.valFromOption(findTrueConditionLogic)), (function (action) {
          var match = action.actionType;
          if (match.TAG === "Redirection") {
            return true;
          } else {
            return false;
          }
        }));
  if (redirectionLogic === undefined) {
    return ;
  }
  var redirectionUrl = Action$ReactHooksTemplate.actionType(redirectionLogic);
  if (redirectionUrl.TAG !== "Redirection") {
    return ;
  }
  var redirectionUrl$1 = redirectionUrl._0;
  if (redirectionUrl$1 !== undefined) {
    return RedirectionUrl$ReactHooksTemplate.id(redirectionUrl$1);
  }
  
}

function submitQuestionResponses(completedOpt, state, survey) {
  var completed = completedOpt !== undefined ? completedOpt : false;
  var redirectionUrlId = findMatchingRedirectionUrlId(state, survey);
  var baseParams_0 = [
    "token",
    state.id
  ];
  var baseParams_1 = {
    hd: [
      "responses",
      surveyAnswers(state.embeddedLogic ? LogicGraph$ReactHooksTemplate.path(state.graph) : Belt_List.keepMap(SurveyNavigator$ReactHooksTemplate.path(state.surveyNavigator), (function (node) {
                    switch (node.TAG) {
                      case "Welcome" :
                      case "ThankYou" :
                          return ;
                      case "Question" :
                          var q = node._0;
                          if (Question$ReactHooksTemplate.answered(q)) {
                            return q;
                          } else {
                            return ;
                          }
                      
                    }
                  })))
    ],
    tl: {
      hd: [
        "language_code",
        SurveyLanguage$ReactHooksTemplate.code(state.language)
      ],
      tl: {
        hd: [
          "completed",
          completed
        ],
        tl: /* [] */0
      }
    }
  };
  var baseParams = {
    hd: baseParams_0,
    tl: baseParams_1
  };
  var paramsWithRedirection = redirectionUrlId !== undefined ? Belt_List.concatMany([
          baseParams,
          {
            hd: [
              "redirection_url_id",
              redirectionUrlId
            ],
            tl: /* [] */0
          }
        ]) : baseParams;
  Http$ReactHooksTemplate.fetchPostEncodedJSON("/api/v1/user_response", Json_encode.object_({
            hd: [
              "api",
              Json_encode.object_(paramsWithRedirection)
            ],
            tl: /* [] */0
          }));
}

function allQuestions(surveyNavigator) {
  return Belt_List.keepMap(SurveyNavigator$ReactHooksTemplate.nodes(surveyNavigator), (function (x) {
                switch (x.TAG) {
                  case "Welcome" :
                  case "ThankYou" :
                      return ;
                  case "Question" :
                      return x._0;
                  
                }
              }));
}

function allThankYous(surveyNavigator) {
  return Belt_List.keepMap(SurveyNavigator$ReactHooksTemplate.nodes(surveyNavigator), (function (x) {
                switch (x.TAG) {
                  case "ThankYou" :
                      return Caml_option.some(x._0);
                  case "Welcome" :
                  case "Question" :
                      return ;
                  
                }
              }));
}

function isSinglePage(survey, client) {
  var isMultiplePageEnforced = List.exists((function (x) {
          var policy = ApplicationSetting$ReactHooksTemplate.individualSetting(x);
          if (policy.TAG === "PaginationPolicies" && ApplicationSetting$ReactHooksTemplate.enforced(x)) {
            return PaginationPolicies$ReactHooksTemplate.value(policy._0) === "MultiplePageSurvey";
          } else {
            return false;
          }
        }), Survey$ReactHooksTemplate.applicationSettings(survey));
  var isSinglePageEnforced = List.exists((function (x) {
          var policy = ApplicationSetting$ReactHooksTemplate.individualSetting(x);
          if (policy.TAG === "PaginationPolicies" && ApplicationSetting$ReactHooksTemplate.enforced(x)) {
            return PaginationPolicies$ReactHooksTemplate.value(policy._0) === "SinglePageSurvey";
          } else {
            return false;
          }
        }), Survey$ReactHooksTemplate.applicationSettings(survey));
  var orgSettings = OrganizationProfile$ReactHooksTemplate.applicationSettings(client);
  var orgPolicy = List.find_opt((function (x) {
          var match = ApplicationSetting$ReactHooksTemplate.individualSetting(x);
          if (match.TAG === "PaginationPolicies") {
            return true;
          } else {
            return false;
          }
        }), orgSettings);
  if (orgPolicy !== undefined) {
    var setting = Caml_option.valFromOption(orgPolicy);
    var policy = ApplicationSetting$ReactHooksTemplate.individualSetting(setting);
    if (policy.TAG !== "PaginationPolicies") {
      return false;
    }
    var policy$1 = policy._0;
    if (ApplicationSetting$ReactHooksTemplate.enforced(setting)) {
      return PaginationPolicies$ReactHooksTemplate.value(policy$1) === "SinglePageSurvey";
    }
    if (isMultiplePageEnforced) {
      return false;
    }
    if (isSinglePageEnforced) {
      return true;
    }
    var match = Survey$ReactHooksTemplate.paginationSettings(survey);
    if (match === undefined) {
      return PaginationPolicies$ReactHooksTemplate.value(policy$1) === "SinglePageSurvey";
    }
    if (typeof match === "object") {
      return false;
    }
    if (match === "SinglePage") {
      return true;
    }
    var mappings = survey.pageMappings;
    if (mappings !== undefined) {
      return List.length(mappings) <= 0;
    } else {
      return true;
    }
  } else {
    if (isMultiplePageEnforced) {
      return false;
    }
    if (isSinglePageEnforced) {
      return true;
    }
    var match$1 = Survey$ReactHooksTemplate.paginationSettings(survey);
    if (match$1 === undefined) {
      return false;
    }
    if (typeof match$1 === "object") {
      return false;
    }
    if (match$1 === "SinglePage") {
      return true;
    }
    var mappings$1 = survey.pageMappings;
    if (mappings$1 !== undefined) {
      return List.length(mappings$1) <= 0;
    } else {
      return true;
    }
  }
}

function reducer(state, action) {
  var singlePage = isSinglePage(state.survey, state.client);
  if (typeof action !== "object") {
    var questionView = singlePage ? ({
          TAG: "MultipleQuestions",
          _0: SurveyNavigator$ReactHooksTemplate.questions(state.surveyNavigator)
        }) : getQuestionView(state.survey, state.currentPage, singlePage);
    return {
            id: state.id,
            name: state.name,
            logo: state.logo,
            preview: state.preview,
            currentPreview: {
              TAG: "QuestionPage",
              _0: questionTemplates,
              _1: questionView,
              _2: state.customerInfo
            },
            graph: state.graph,
            surveyNavigator: state.surveyNavigator,
            customerInfo: state.customerInfo,
            theme: state.theme,
            client: state.client,
            transactionStatus: state.transactionStatus,
            surveyLanguages: state.surveyLanguages,
            language: state.language,
            applicationSettings: state.applicationSettings,
            embeddedLogic: state.embeddedLogic,
            currentPage: state.currentPage,
            totalPages: state.totalPages,
            survey: state.survey,
            verificationCode: state.verificationCode
          };
  }
  switch (action.TAG) {
    case "UpdateQuestion" :
        var question = action._0;
        var surveyNavigator$p = SurveyNavigator$ReactHooksTemplate.updateNode({
              TAG: "Question",
              _0: question
            }, state.surveyNavigator);
        var graph = SurveyLogic$ReactHooksTemplate.addLogicToEdges(allQuestions(surveyNavigator$p), SurveyLogic$ReactHooksTemplate.changeEdges(state.name, allQuestions(surveyNavigator$p), allThankYous(surveyNavigator$p), addQuestionsToGraph(allQuestions(surveyNavigator$p), LogicGraph$ReactHooksTemplate.path(state.graph))));
        var graph$p = Question$ReactHooksTemplate.answered(question) ? LogicGraph$ReactHooksTemplate.addQuestionToPath(question, graph) : LogicGraph$ReactHooksTemplate.removeQuestionFromPath(question, graph);
        var newrecord = Caml_obj.obj_dup(state.survey);
        newrecord.questions = SurveyNavigator$ReactHooksTemplate.questions(surveyNavigator$p);
        var totalPages = calculateTotalPages(newrecord);
        var questionView$1 = getQuestionView(newrecord, state.currentPage, isSinglePage(newrecord, state.client));
        return {
                id: state.id,
                name: state.name,
                logo: state.logo,
                preview: state.preview,
                currentPreview: {
                  TAG: "QuestionPage",
                  _0: questionTemplates,
                  _1: questionView$1,
                  _2: state.customerInfo
                },
                graph: graph$p,
                surveyNavigator: surveyNavigator$p,
                customerInfo: state.customerInfo,
                theme: state.theme,
                client: state.client,
                transactionStatus: state.transactionStatus,
                surveyLanguages: state.surveyLanguages,
                language: state.language,
                applicationSettings: state.applicationSettings,
                embeddedLogic: state.embeddedLogic,
                currentPage: state.currentPage,
                totalPages: totalPages,
                survey: state.survey,
                verificationCode: state.verificationCode
              };
    case "ChangeLanguage" :
        return {
                id: state.id,
                name: state.name,
                logo: state.logo,
                preview: state.preview,
                currentPreview: state.currentPreview,
                graph: state.graph,
                surveyNavigator: state.surveyNavigator,
                customerInfo: state.customerInfo,
                theme: state.theme,
                client: state.client,
                transactionStatus: state.transactionStatus,
                surveyLanguages: state.surveyLanguages,
                language: action._0,
                applicationSettings: state.applicationSettings,
                embeddedLogic: state.embeddedLogic,
                currentPage: state.currentPage,
                totalPages: state.totalPages,
                survey: state.survey,
                verificationCode: state.verificationCode
              };
    case "SetPage" :
        var page = action._0;
        switch (page.TAG) {
          case "QuestionPage" :
              return {
                      id: state.id,
                      name: state.name,
                      logo: state.logo,
                      preview: state.preview,
                      currentPreview: page,
                      graph: state.graph,
                      surveyNavigator: state.surveyNavigator,
                      customerInfo: state.customerInfo,
                      theme: state.theme,
                      client: state.client,
                      transactionStatus: state.transactionStatus,
                      surveyLanguages: state.surveyLanguages,
                      language: state.language,
                      applicationSettings: state.applicationSettings,
                      embeddedLogic: state.embeddedLogic,
                      currentPage: state.currentPage,
                      totalPages: state.totalPages,
                      survey: state.survey,
                      verificationCode: state.verificationCode
                    };
          case "Welcome" :
          case "ThankYou" :
              break;
          
        }
        return {
                id: state.id,
                name: state.name,
                logo: state.logo,
                preview: state.preview,
                currentPreview: page,
                graph: state.graph,
                surveyNavigator: state.surveyNavigator,
                customerInfo: state.customerInfo,
                theme: state.theme,
                client: state.client,
                transactionStatus: state.transactionStatus,
                surveyLanguages: state.surveyLanguages,
                language: state.language,
                applicationSettings: state.applicationSettings,
                embeddedLogic: state.embeddedLogic,
                currentPage: state.currentPage,
                totalPages: state.totalPages,
                survey: state.survey,
                verificationCode: state.verificationCode
              };
    case "NextPage" :
        var page$1 = action._0;
        switch (page$1.TAG) {
          case "Welcome" :
              var questionView$2 = singlePage ? ({
                    TAG: "MultipleQuestions",
                    _0: SurveyNavigator$ReactHooksTemplate.questions(state.surveyNavigator)
                  }) : getQuestionView(state.survey, state.currentPage, singlePage);
              return {
                      id: state.id,
                      name: state.name,
                      logo: state.logo,
                      preview: state.preview,
                      currentPreview: {
                        TAG: "QuestionPage",
                        _0: questionTemplates,
                        _1: questionView$2,
                        _2: state.customerInfo
                      },
                      graph: state.graph,
                      surveyNavigator: state.surveyNavigator,
                      customerInfo: state.customerInfo,
                      theme: state.theme,
                      client: state.client,
                      transactionStatus: state.transactionStatus,
                      surveyLanguages: state.surveyLanguages,
                      language: state.language,
                      applicationSettings: state.applicationSettings,
                      embeddedLogic: state.embeddedLogic,
                      currentPage: state.currentPage,
                      totalPages: state.totalPages,
                      survey: state.survey,
                      verificationCode: state.verificationCode
                    };
          case "QuestionPage" :
              var questionView$3 = page$1._1;
              if (questionView$3.TAG === "SingleQuestion") {
                var question$1 = questionView$3._0;
                if (question$1 === undefined) {
                  return state;
                }
                var match = getNextNode(state, {
                      TAG: "Question",
                      _0: question$1
                    });
                if (match !== undefined) {
                  switch (match.TAG) {
                    case "Welcome" :
                        return state;
                    case "ThankYou" :
                        if (state.preview) {
                          
                        } else {
                          submitQuestionResponses(true, state, state.survey);
                        }
                        return {
                                id: state.id,
                                name: state.name,
                                logo: state.logo,
                                preview: state.preview,
                                currentPreview: {
                                  TAG: "ThankYou",
                                  _0: Caml_option.some(match._0)
                                },
                                graph: state.graph,
                                surveyNavigator: state.surveyNavigator,
                                customerInfo: state.customerInfo,
                                theme: state.theme,
                                client: state.client,
                                transactionStatus: state.transactionStatus,
                                surveyLanguages: state.surveyLanguages,
                                language: state.language,
                                applicationSettings: state.applicationSettings,
                                embeddedLogic: state.embeddedLogic,
                                currentPage: state.currentPage,
                                totalPages: state.totalPages,
                                survey: state.survey,
                                verificationCode: state.verificationCode
                              };
                    case "Question" :
                        var nextQuestion = match._0;
                        var saveResponse = !state.preview && ApplicationSettings$ReactHooksTemplate.savePartialResponse(state.applicationSettings) && Question$ReactHooksTemplate.answered(question$1);
                        if (saveResponse) {
                          submitQuestionResponses(false, state, state.survey);
                        }
                        var x = Question$ReactHooksTemplate.questionType(nextQuestion);
                        var question$p;
                        switch (x.TAG) {
                          case "RatingGroup" :
                              var x$1 = x._0;
                              var id = RatingGroup$ReactHooksTemplate.carryForwardFrom(x$1);
                              var groupsFromQuestion;
                              if (id !== undefined) {
                                var id$1 = Caml_option.valFromOption(id);
                                groupsFromQuestion = List.find((function (y) {
                                        return Caml_obj.equal(Question$ReactHooksTemplate.uuid(y), id$1);
                                      }), SurveyNavigator$ReactHooksTemplate.questions(state.surveyNavigator));
                              } else {
                                groupsFromQuestion = nextQuestion;
                              }
                              var y = Question$ReactHooksTemplate.questionType(groupsFromQuestion);
                              if (y.TAG === "MultipleSelect") {
                                var y$1 = y._0;
                                var choices = MultipleSelect$ReactHooksTemplate.getAnswer(y$1);
                                question$p = Question$ReactHooksTemplate.setQuestionType(nextQuestion, {
                                      TAG: "RatingGroup",
                                      _0: RatingGroup$ReactHooksTemplate.setGroups(x$1, List.map((function (z) {
                                                  return [
                                                          RandomId$ReactHooksTemplate.toString(MultipleSelect$ReactHooksTemplate.choiceId(z)),
                                                          MultipleSelect$ReactHooksTemplate.getChoiceText(z)
                                                        ];
                                                }), choices !== undefined ? choices : MultipleSelect$ReactHooksTemplate.choices(y$1)))
                                    });
                              } else {
                                question$p = nextQuestion;
                              }
                              break;
                          case "MultipleSelect" :
                              var x$2 = x._0;
                              var id$2 = MultipleSelect$ReactHooksTemplate.carryForwardFrom(x$2);
                              if (id$2 !== undefined) {
                                var id$3 = Caml_option.valFromOption(id$2);
                                var optionsFromQuestion = List.find((function (y) {
                                        return Caml_obj.equal(Question$ReactHooksTemplate.uuid(y), id$3);
                                      }), SurveyNavigator$ReactHooksTemplate.questions(state.surveyNavigator));
                                var y$2 = Question$ReactHooksTemplate.questionType(optionsFromQuestion);
                                if (y$2.TAG === "MultipleSelect") {
                                  var y$3 = y$2._0;
                                  var choices$1 = MultipleSelect$ReactHooksTemplate.getAnswer(y$3);
                                  question$p = Question$ReactHooksTemplate.setQuestionType(nextQuestion, {
                                        TAG: "MultipleSelect",
                                        _0: MultipleSelect$ReactHooksTemplate.setChoices(choices$1 !== undefined ? List.filter(function (z) {
                                                      return List.exists((function (b) {
                                                                    return Caml_obj.equal(MultipleSelect$ReactHooksTemplate.choiceId(z), MultipleSelect$ReactHooksTemplate.choiceId(b));
                                                                  }), choices$1);
                                                    })(MultipleSelect$ReactHooksTemplate.choices(y$3)) : MultipleSelect$ReactHooksTemplate.choices(y$3), x$2)
                                      });
                                } else {
                                  question$p = nextQuestion;
                                }
                              } else {
                                question$p = nextQuestion;
                              }
                              break;
                          default:
                            question$p = nextQuestion;
                        }
                        var surveyNavigator$p$1 = SurveyNavigator$ReactHooksTemplate.updateNode({
                              TAG: "Question",
                              _0: question$p
                            }, state.surveyNavigator);
                        var graph$p$1 = LogicGraph$ReactHooksTemplate.addQuestionToPath(question$p, SurveyLogic$ReactHooksTemplate.addLogicToEdges(allQuestions(surveyNavigator$p$1), SurveyLogic$ReactHooksTemplate.changeEdges(state.name, allQuestions(surveyNavigator$p$1), allThankYous(surveyNavigator$p$1), addQuestionsToGraph(allQuestions(surveyNavigator$p$1), LogicGraph$ReactHooksTemplate.path(state.graph)))));
                        return {
                                id: state.id,
                                name: state.name,
                                logo: state.logo,
                                preview: state.preview,
                                currentPreview: {
                                  TAG: "QuestionPage",
                                  _0: questionTemplates,
                                  _1: {
                                    TAG: "SingleQuestion",
                                    _0: question$p
                                  },
                                  _2: state.customerInfo
                                },
                                graph: graph$p$1,
                                surveyNavigator: surveyNavigator$p$1,
                                customerInfo: state.customerInfo,
                                theme: state.theme,
                                client: state.client,
                                transactionStatus: state.transactionStatus,
                                surveyLanguages: state.surveyLanguages,
                                language: state.language,
                                applicationSettings: state.applicationSettings,
                                embeddedLogic: state.embeddedLogic,
                                currentPage: state.currentPage + 1 | 0,
                                totalPages: state.totalPages,
                                survey: state.survey,
                                verificationCode: state.verificationCode
                              };
                    
                  }
                } else {
                  if (state.preview) {
                    
                  } else {
                    submitQuestionResponses(true, state, state.survey);
                  }
                  return {
                          id: state.id,
                          name: state.name,
                          logo: state.logo,
                          preview: state.preview,
                          currentPreview: {
                            TAG: "ThankYou",
                            _0: undefined
                          },
                          graph: state.graph,
                          surveyNavigator: state.surveyNavigator,
                          customerInfo: state.customerInfo,
                          theme: state.theme,
                          client: state.client,
                          transactionStatus: state.transactionStatus,
                          surveyLanguages: state.surveyLanguages,
                          language: state.language,
                          applicationSettings: state.applicationSettings,
                          embeddedLogic: state.embeddedLogic,
                          currentPage: state.currentPage,
                          totalPages: state.totalPages,
                          survey: state.survey,
                          verificationCode: state.verificationCode
                        };
                }
              } else {
                if (singlePage) {
                  submitQuestionResponses(true, state, state.survey);
                  return {
                          id: state.id,
                          name: state.name,
                          logo: state.logo,
                          preview: state.preview,
                          currentPreview: {
                            TAG: "ThankYou",
                            _0: SurveyNavigator$ReactHooksTemplate.thankYou(state.surveyNavigator)
                          },
                          graph: state.graph,
                          surveyNavigator: state.surveyNavigator,
                          customerInfo: state.customerInfo,
                          theme: state.theme,
                          client: state.client,
                          transactionStatus: state.transactionStatus,
                          surveyLanguages: state.surveyLanguages,
                          language: state.language,
                          applicationSettings: state.applicationSettings,
                          embeddedLogic: state.embeddedLogic,
                          currentPage: state.currentPage,
                          totalPages: state.totalPages,
                          survey: state.survey,
                          verificationCode: state.verificationCode
                        };
                }
                var currentQuestions;
                switch (page$1.TAG) {
                  case "QuestionPage" :
                      var qs = page$1._1;
                      currentQuestions = qs.TAG === "SingleQuestion" ? /* [] */0 : qs._0;
                      break;
                  case "Welcome" :
                  case "ThankYou" :
                      currentQuestions = /* [] */0;
                      break;
                  
                }
                var answered = Belt_List.some(currentQuestions, Question$ReactHooksTemplate.answered);
                var saveResponse$1 = !state.preview && ApplicationSettings$ReactHooksTemplate.savePartialResponse(state.applicationSettings) && answered;
                if (saveResponse$1) {
                  submitQuestionResponses(false, state, state.survey);
                }
                var newrecord$1 = Caml_obj.obj_dup(state.survey);
                newrecord$1.questions = SurveyNavigator$ReactHooksTemplate.questions(state.surveyNavigator);
                if (state.currentPage < state.totalPages) {
                  var nextPageIndex = state.currentPage + 1 | 0;
                  var findNextPageWithQuestions = function (_pageIndex) {
                    while(true) {
                      var pageIndex = _pageIndex;
                      if (pageIndex > state.totalPages) {
                        return [
                                pageIndex,
                                /* [] */0
                              ];
                      }
                      var questionsForPage = getQuestionsForCurrentPage(newrecord$1, pageIndex);
                      if (List.length(questionsForPage) > 0) {
                        return [
                                pageIndex,
                                questionsForPage
                              ];
                      }
                      _pageIndex = pageIndex + 1 | 0;
                      continue ;
                    };
                  };
                  var match$1 = findNextPageWithQuestions(nextPageIndex);
                  var nextQuestionPage = match$1[0];
                  if (List.length(match$1[1]) > 0) {
                    var questionView$4 = getQuestionView(newrecord$1, nextQuestionPage, singlePage);
                    return {
                            id: state.id,
                            name: state.name,
                            logo: state.logo,
                            preview: state.preview,
                            currentPreview: {
                              TAG: "QuestionPage",
                              _0: questionTemplates,
                              _1: questionView$4,
                              _2: state.customerInfo
                            },
                            graph: state.graph,
                            surveyNavigator: state.surveyNavigator,
                            customerInfo: state.customerInfo,
                            theme: state.theme,
                            client: state.client,
                            transactionStatus: state.transactionStatus,
                            surveyLanguages: state.surveyLanguages,
                            language: state.language,
                            applicationSettings: state.applicationSettings,
                            embeddedLogic: state.embeddedLogic,
                            currentPage: nextQuestionPage,
                            totalPages: state.totalPages,
                            survey: state.survey,
                            verificationCode: state.verificationCode
                          };
                  }
                  submitQuestionResponses(true, state, state.survey);
                  return {
                          id: state.id,
                          name: state.name,
                          logo: state.logo,
                          preview: state.preview,
                          currentPreview: {
                            TAG: "ThankYou",
                            _0: undefined
                          },
                          graph: state.graph,
                          surveyNavigator: state.surveyNavigator,
                          customerInfo: state.customerInfo,
                          theme: state.theme,
                          client: state.client,
                          transactionStatus: state.transactionStatus,
                          surveyLanguages: state.surveyLanguages,
                          language: state.language,
                          applicationSettings: state.applicationSettings,
                          embeddedLogic: state.embeddedLogic,
                          currentPage: state.currentPage,
                          totalPages: state.totalPages,
                          survey: state.survey,
                          verificationCode: state.verificationCode
                        };
                }
                submitQuestionResponses(true, state, state.survey);
                return {
                        id: state.id,
                        name: state.name,
                        logo: state.logo,
                        preview: state.preview,
                        currentPreview: {
                          TAG: "ThankYou",
                          _0: SurveyNavigator$ReactHooksTemplate.thankYou(state.surveyNavigator)
                        },
                        graph: state.graph,
                        surveyNavigator: state.surveyNavigator,
                        customerInfo: state.customerInfo,
                        theme: state.theme,
                        client: state.client,
                        transactionStatus: state.transactionStatus,
                        surveyLanguages: state.surveyLanguages,
                        language: state.language,
                        applicationSettings: state.applicationSettings,
                        embeddedLogic: state.embeddedLogic,
                        currentPage: state.currentPage,
                        totalPages: state.totalPages,
                        survey: state.survey,
                        verificationCode: state.verificationCode
                      };
              }
          case "ThankYou" :
              return state;
          
        }
    case "PrevPage" :
        var page$2 = action._0;
        switch (page$2.TAG) {
          case "QuestionPage" :
              var questionView$5 = page$2._1;
              if (questionView$5.TAG === "SingleQuestion") {
                var question$2 = questionView$5._0;
                if (question$2 === undefined) {
                  return state;
                }
                var match$2 = getPreviousNode(state, {
                      TAG: "Question",
                      _0: question$2
                    });
                if (match$2 === undefined) {
                  return state;
                }
                switch (match$2.TAG) {
                  case "Welcome" :
                      return {
                              id: state.id,
                              name: state.name,
                              logo: state.logo,
                              preview: state.preview,
                              currentPreview: {
                                TAG: "Welcome",
                                _0: Caml_option.some(match$2._0)
                              },
                              graph: state.graph,
                              surveyNavigator: state.surveyNavigator,
                              customerInfo: state.customerInfo,
                              theme: state.theme,
                              client: state.client,
                              transactionStatus: state.transactionStatus,
                              surveyLanguages: state.surveyLanguages,
                              language: state.language,
                              applicationSettings: state.applicationSettings,
                              embeddedLogic: state.embeddedLogic,
                              currentPage: state.currentPage,
                              totalPages: state.totalPages,
                              survey: state.survey,
                              verificationCode: state.verificationCode
                            };
                  case "ThankYou" :
                      return state;
                  case "Question" :
                      return {
                              id: state.id,
                              name: state.name,
                              logo: state.logo,
                              preview: state.preview,
                              currentPreview: {
                                TAG: "QuestionPage",
                                _0: questionTemplates,
                                _1: {
                                  TAG: "SingleQuestion",
                                  _0: match$2._0
                                },
                                _2: state.customerInfo
                              },
                              graph: LogicGraph$ReactHooksTemplate.removeQuestionFromPath(question$2, state.graph),
                              surveyNavigator: state.surveyNavigator,
                              customerInfo: state.customerInfo,
                              theme: state.theme,
                              client: state.client,
                              transactionStatus: state.transactionStatus,
                              surveyLanguages: state.surveyLanguages,
                              language: state.language,
                              applicationSettings: state.applicationSettings,
                              embeddedLogic: state.embeddedLogic,
                              currentPage: state.currentPage,
                              totalPages: state.totalPages,
                              survey: state.survey,
                              verificationCode: state.verificationCode
                            };
                  
                }
              } else {
                if (state.currentPage <= 1) {
                  return state;
                }
                var prevPage = state.currentPage - 1 | 0;
                var newrecord$2 = Caml_obj.obj_dup(state.survey);
                newrecord$2.questions = SurveyNavigator$ReactHooksTemplate.questions(state.surveyNavigator);
                var findPrevPageWithQuestions = function (_pageIndex) {
                  while(true) {
                    var pageIndex = _pageIndex;
                    if (pageIndex < 1) {
                      return [
                              pageIndex,
                              /* [] */0
                            ];
                    }
                    var questionsForPage = getQuestionsForCurrentPage(newrecord$2, pageIndex);
                    if (List.length(questionsForPage) > 0) {
                      return [
                              pageIndex,
                              questionsForPage
                            ];
                    }
                    _pageIndex = pageIndex - 1 | 0;
                    continue ;
                  };
                };
                var match$3 = findPrevPageWithQuestions(prevPage);
                var prevQuestionPage = match$3[0];
                if (List.length(match$3[1]) <= 0) {
                  return state;
                }
                var questionView$6 = getQuestionView(newrecord$2, prevQuestionPage, isSinglePage(newrecord$2, state.client));
                return {
                        id: state.id,
                        name: state.name,
                        logo: state.logo,
                        preview: state.preview,
                        currentPreview: {
                          TAG: "QuestionPage",
                          _0: questionTemplates,
                          _1: questionView$6,
                          _2: state.customerInfo
                        },
                        graph: state.graph,
                        surveyNavigator: state.surveyNavigator,
                        customerInfo: state.customerInfo,
                        theme: state.theme,
                        client: state.client,
                        transactionStatus: state.transactionStatus,
                        surveyLanguages: state.surveyLanguages,
                        language: state.language,
                        applicationSettings: state.applicationSettings,
                        embeddedLogic: state.embeddedLogic,
                        currentPage: prevQuestionPage,
                        totalPages: state.totalPages,
                        survey: state.survey,
                        verificationCode: state.verificationCode
                      };
              }
          case "Welcome" :
          case "ThankYou" :
              return state;
          
        }
    
  }
}

function defaultWelcome(param) {
  return Welcome$ReactHooksTemplate.make("Your opinion matters!", "Rate our products and services.", "Take the survey", param);
}

var defaultThankYou = ThankYou$ReactHooksTemplate.make("Thank you for taking the time to give your valuable feedback!");

function defaultOpinionScale(param) {
  var arg = OpinionScaleLabel$ReactHooksTemplate.make("Left", "Center", "Right");
  var arg$1 = RandomId$ReactHooksTemplate.generate();
  return function (param) {
    return OpinionScale$ReactHooksTemplate.make("Likely to recommend", "NPS Score", param, arg, arg$1);
  };
}

function defaultStarRating(param) {
  return StarRating$ReactHooksTemplate.make("Star Rating", "Rate our services", RandomId$ReactHooksTemplate.generate());
}

function defaultLongText(param) {
  var arg = RandomId$ReactHooksTemplate.generate();
  return function (param) {
    return function (param$1) {
      return LongText$ReactHooksTemplate.make("Long Text Question", "Share the reasons for your rating", param, param$1, arg);
    };
  };
}

function defaultShortText(param) {
  var arg = RandomId$ReactHooksTemplate.generate();
  return function (param) {
    return function (param$1) {
      return ShortText$ReactHooksTemplate.make("Short Text Question", "Enter Short Text..", param, param$1, arg);
    };
  };
}

function saveForm(surveyId, welcome, questions, thankYou, logicalJumpGroup) {
  var params = {};
  params["survey"] = surveyToJson(welcome, questions, thankYou, logicalJumpGroup);
  return Http$ReactHooksTemplate.fetchPostJSON("/api/v1/surveys/" + surveyId + "/bulk_create", params);
}

function SurveyView(props) {
  var currentPage = props.currentPage;
  var __params = props.params;
  var preview = props.preview;
  var customerInfo = props.customerInfo;
  var transactionStatus = props.transactionStatus;
  var client = props.client;
  var survey = props.survey;
  var params = __params !== undefined ? __params : "";
  var substitutionVariables = Belt_Option.getWithDefault(props.substitutionVariables, {});
  var params$1 = Querystringify.parse(params);
  var surveyNavigator = SurveyNavigator$ReactHooksTemplate.create(survey);
  var questions = SurveyNavigator$ReactHooksTemplate.questions(surveyNavigator);
  var graph = SurveyLogic$ReactHooksTemplate.addLogicToEdges(allQuestions(surveyNavigator), SurveyLogic$ReactHooksTemplate.changeEdges(Survey$ReactHooksTemplate.name(survey), allQuestions(surveyNavigator), allThankYous(surveyNavigator), addQuestionsToGraph(allQuestions(surveyNavigator), LogicGraph$ReactHooksTemplate.path(LogicGraph$ReactHooksTemplate.empty()))));
  var match = SurveyNavigator$ReactHooksTemplate.startNode(surveyNavigator);
  var currentPreview;
  if (match !== undefined) {
    switch (match.TAG) {
      case "Welcome" :
          currentPreview = {
            TAG: "Welcome",
            _0: Caml_option.some(match._0)
          };
          break;
      case "ThankYou" :
          currentPreview = {
            TAG: "ThankYou",
            _0: Caml_option.some(match._0)
          };
          break;
      case "Question" :
          var singlePage = isSinglePage(survey, client);
          var questionView = singlePage ? ({
                TAG: "MultipleQuestions",
                _0: questions
              }) : getQuestionView(survey, currentPage, singlePage);
          currentPreview = {
            TAG: "QuestionPage",
            _0: questionTemplates,
            _1: questionView,
            _2: customerInfo
          };
          break;
      
    }
  } else {
    currentPreview = undefined;
  }
  var emptyState_id = props.token;
  var emptyState_name = Survey$ReactHooksTemplate.name(survey);
  var emptyState_logo = Survey$ReactHooksTemplate.logo(survey);
  var emptyState_surveyNavigator = SurveyNavigator$ReactHooksTemplate.create(survey);
  var emptyState_theme = Survey$ReactHooksTemplate.surveyTheme(survey);
  var emptyState_surveyLanguages = props.surveyLanguages;
  var emptyState_language = props.language;
  var emptyState_applicationSettings = props.applicationSettings;
  var emptyState_embeddedLogic = List.length(Survey$ReactHooksTemplate.logics(survey)) === 0;
  var emptyState_totalPages = isSinglePage(survey, client) ? 1 : calculateTotalPages(survey);
  var emptyState_verificationCode = props.verificationCode;
  var emptyState = {
    id: emptyState_id,
    name: emptyState_name,
    logo: emptyState_logo,
    preview: preview,
    currentPreview: currentPreview,
    graph: graph,
    surveyNavigator: emptyState_surveyNavigator,
    customerInfo: customerInfo,
    theme: emptyState_theme,
    client: client,
    transactionStatus: transactionStatus,
    surveyLanguages: emptyState_surveyLanguages,
    language: emptyState_language,
    applicationSettings: emptyState_applicationSettings,
    embeddedLogic: emptyState_embeddedLogic,
    currentPage: currentPage,
    totalPages: emptyState_totalPages,
    survey: survey,
    verificationCode: emptyState_verificationCode
  };
  var match$1 = React.useReducer(reducer, emptyState);
  var dispatch = match$1[1];
  var state = match$1[0];
  var match$2 = React.useState(function (param) {
        return "Loading";
      });
  var setMode = match$2[1];
  var x = Js_dict.get(params$1, "ltr");
  var nps = x !== undefined ? x : Js_dict.get(params$1, "smiley_rating");
  React.useEffect((function (param) {
          var exit = 0;
          switch (transactionStatus) {
            case "closed" :
            case "completed" :
                exit = 1;
                break;
            default:
              var exit$1 = 0;
              if (nps !== undefined && nps !== "") {
                var firstQuestion = Belt_List.head(Survey$ReactHooksTemplate.questions(survey));
                if (firstQuestion !== undefined) {
                  var questionType = Question$ReactHooksTemplate.questionType(firstQuestion);
                  switch (questionType.TAG) {
                    case "Nps" :
                        var nps$1 = questionType._0;
                        var answer = Caml_format.float_of_string(nps) | 0;
                        if (answer >= 0 && answer < 11) {
                          var updatedNps = Nps$ReactHooksTemplate.answered(nps$1) && Nps$ReactHooksTemplate.answerToString(nps$1) === String(answer) ? Nps$ReactHooksTemplate.setAnswer(Nps$ReactHooksTemplate.setAnswer(nps$1, answer), answer) : Nps$ReactHooksTemplate.setAnswer(nps$1, answer);
                          var question = Question$ReactHooksTemplate.setQuestionType(firstQuestion, {
                                TAG: "Nps",
                                _0: updatedNps
                              });
                          Curry._1(dispatch, {
                                TAG: "UpdateQuestion",
                                _0: question
                              });
                          if (isSinglePage(survey, client)) {
                            Curry._1(dispatch, {
                                  TAG: "NextPage",
                                  _0: {
                                    TAG: "QuestionPage",
                                    _0: questionTemplates,
                                    _1: {
                                      TAG: "MultipleQuestions",
                                      _0: Survey$ReactHooksTemplate.questions(survey)
                                    },
                                    _2: customerInfo
                                  }
                                });
                          } else {
                            Curry._1(dispatch, {
                                  TAG: "NextPage",
                                  _0: {
                                    TAG: "QuestionPage",
                                    _0: questionTemplates,
                                    _1: {
                                      TAG: "SingleQuestion",
                                      _0: question
                                    },
                                    _2: customerInfo
                                  }
                                });
                          }
                        } else {
                          Curry._1(dispatch, "PreviewQuestions");
                        }
                        break;
                    case "SmileyRating" :
                        var smileyRating = questionType._0;
                        var answer$1 = List.find_opt((function (x) {
                                return SmileyRating$ReactHooksTemplate.ratingTypeToRating(x) === Caml_format.int_of_string(nps);
                              }), SmileyRating$ReactHooksTemplate.ratingTypeCollection(smileyRating));
                        if (answer$1 !== undefined) {
                          var updatedSmileyRating = SmileyRating$ReactHooksTemplate.setAnswer(smileyRating, answer$1);
                          var question$1 = Question$ReactHooksTemplate.setQuestionType(firstQuestion, {
                                TAG: "SmileyRating",
                                _0: updatedSmileyRating
                              });
                          Curry._1(dispatch, {
                                TAG: "UpdateQuestion",
                                _0: question$1
                              });
                          if (isSinglePage(survey, client)) {
                            Curry._1(dispatch, {
                                  TAG: "NextPage",
                                  _0: {
                                    TAG: "QuestionPage",
                                    _0: questionTemplates,
                                    _1: {
                                      TAG: "MultipleQuestions",
                                      _0: Survey$ReactHooksTemplate.questions(survey)
                                    },
                                    _2: customerInfo
                                  }
                                });
                          } else {
                            Curry._1(dispatch, {
                                  TAG: "NextPage",
                                  _0: {
                                    TAG: "QuestionPage",
                                    _0: questionTemplates,
                                    _1: {
                                      TAG: "SingleQuestion",
                                      _0: question$1
                                    },
                                    _2: customerInfo
                                  }
                                });
                          }
                        } else {
                          Curry._1(dispatch, "PreviewQuestions");
                        }
                        break;
                    default:
                      Curry._1(dispatch, "PreviewQuestions");
                  }
                }
                
              } else {
                exit$1 = 2;
              }
              if (exit$1 === 2) {
                var lastAnsweredQuestion = Belt_List.reduce(Survey$ReactHooksTemplate.questions(survey), undefined, (function (x, y) {
                        if (Question$ReactHooksTemplate.answered(y)) {
                          return y;
                        } else {
                          return x;
                        }
                      }));
                if (lastAnsweredQuestion !== undefined) {
                  if (isSinglePage(survey, client)) {
                    Curry._1(dispatch, {
                          TAG: "NextPage",
                          _0: {
                            TAG: "QuestionPage",
                            _0: questionTemplates,
                            _1: {
                              TAG: "MultipleQuestions",
                              _0: Survey$ReactHooksTemplate.questions(survey)
                            },
                            _2: customerInfo
                          }
                        });
                  } else {
                    Curry._1(dispatch, {
                          TAG: "NextPage",
                          _0: {
                            TAG: "QuestionPage",
                            _0: questionTemplates,
                            _1: {
                              TAG: "SingleQuestion",
                              _0: lastAnsweredQuestion
                            },
                            _2: customerInfo
                          }
                        });
                  }
                }
                
              }
              Curry._1(setMode, (function (param) {
                      return "Ready";
                    }));
          }
          if (exit === 1) {
            Curry._1(setMode, (function (param) {
                    return "Expired";
                  }));
          }
          
        }), []);
  var onNextButtonClick = function (param) {
    var preview = state.currentPreview;
    if (preview !== undefined) {
      return Curry._1(dispatch, {
                  TAG: "NextPage",
                  _0: preview
                });
    }
    
  };
  var onPrevButtonClick = function (param) {
    var preview = state.currentPreview;
    if (preview !== undefined) {
      return Curry._1(dispatch, {
                  TAG: "PrevPage",
                  _0: preview
                });
    }
    
  };
  var surveyPreview = function (type_) {
    var match = state.currentPreview;
    var page;
    if (match !== undefined) {
      switch (match.TAG) {
        case "QuestionPage" :
            var questionView = match._1;
            page = questionView.TAG === "SingleQuestion" && questionView._0 === undefined ? undefined : state.currentPreview;
            break;
        case "Welcome" :
        case "ThankYou" :
            page = state.currentPreview;
            break;
        
      }
    } else {
      page = undefined;
    }
    var match$1 = state.currentPreview;
    var showPreviousButton;
    if (match$1 !== undefined) {
      switch (match$1.TAG) {
        case "QuestionPage" :
            var questionView$1 = match$1._1;
            if (questionView$1.TAG === "SingleQuestion") {
              var q = questionView$1._0;
              if (q !== undefined) {
                var match$2 = getPreviousNode(state, {
                      TAG: "Question",
                      _0: q
                    });
                if (match$2 !== undefined) {
                  switch (match$2.TAG) {
                    case "Welcome" :
                    case "ThankYou" :
                        showPreviousButton = false;
                        break;
                    case "Question" :
                        showPreviousButton = true;
                        break;
                    
                  }
                } else {
                  showPreviousButton = false;
                }
              } else {
                showPreviousButton = false;
              }
            } else {
              var match$3 = state.survey.paginationSettings;
              showPreviousButton = match$3 !== undefined && !(typeof match$3 !== "object" && match$3 === "SinglePage") ? state.currentPage > 1 : false;
            }
            break;
        case "Welcome" :
        case "ThankYou" :
            showPreviousButton = false;
            break;
        
      }
    } else {
      showPreviousButton = false;
    }
    var match$4 = state.currentPreview;
    var showSubmitButton;
    if (match$4 !== undefined) {
      switch (match$4.TAG) {
        case "QuestionPage" :
            var q$1 = match$4._1;
            if (q$1.TAG === "SingleQuestion") {
              var question = q$1._0;
              if (question !== undefined) {
                var match$5 = getNextNode(state, {
                      TAG: "Question",
                      _0: question
                    });
                if (match$5 !== undefined) {
                  switch (match$5.TAG) {
                    case "ThankYou" :
                        showSubmitButton = true;
                        break;
                    case "Welcome" :
                    case "Question" :
                        showSubmitButton = false;
                        break;
                    
                  }
                } else {
                  showSubmitButton = true;
                }
              } else {
                showSubmitButton = false;
              }
            } else {
              var match$6 = state.survey.paginationSettings;
              showSubmitButton = match$6 !== undefined && typeof match$6 !== "object" ? (
                  match$6 === "SinglePage" ? true : Belt_List.some(q$1._0, (function (q) {
                            var match = getNextNode(state, {
                                  TAG: "Question",
                                  _0: q
                                });
                            if (match === undefined) {
                              return true;
                            }
                            switch (match.TAG) {
                              case "ThankYou" :
                                  return true;
                              case "Welcome" :
                              case "Question" :
                                  return false;
                              
                            }
                          }))
                ) : state.currentPage >= state.totalPages;
            }
            break;
        case "Welcome" :
        case "ThankYou" :
            showSubmitButton = false;
            break;
        
      }
    } else {
      showSubmitButton = false;
    }
    var autoAdvance = List.exists((function (x) {
            var y = ApplicationSetting$ReactHooksTemplate.individualSetting(x);
            if (y.TAG === "AutoAdvance") {
              return AutoAdvance$ReactHooksTemplate.value(y._0);
            } else {
              return false;
            }
          }), Survey$ReactHooksTemplate.applicationSettings(survey));
    var autoAdvanceNextPage = function (answered) {
      if (isSinglePage(state.survey, state.client) || !(autoAdvance && answered && page !== undefined)) {
        return ;
      } else {
        setTimeout((function (param) {
                Curry._1(dispatch, {
                      TAG: "NextPage",
                      _0: page
                    });
              }), 300);
        return ;
      }
    };
    var match$7 = state.currentPreview;
    var showNextButton;
    if (match$7 !== undefined) {
      switch (match$7.TAG) {
        case "QuestionPage" :
            var q$2 = match$7._1;
            if (q$2.TAG === "SingleQuestion") {
              var question$1 = q$2._0;
              showNextButton = question$1 !== undefined ? (
                  Question$ReactHooksTemplate.mandatory(question$1) ? Question$ReactHooksTemplate.answered(question$1) && Question$ReactHooksTemplate.isValidAnswer(question$1) : Question$ReactHooksTemplate.isValidAnswer(question$1)
                ) : false;
            } else {
              showNextButton = Belt_List.every(Belt_List.map(q$2._0, (function (y) {
                          if (Question$ReactHooksTemplate.mandatory(y) && !Question$ReactHooksTemplate.answered(y)) {
                            return false;
                          } else {
                            return Question$ReactHooksTemplate.isValidAnswer(y);
                          }
                        })), (function (result) {
                      return result;
                    }));
            }
            break;
        case "Welcome" :
        case "ThankYou" :
            showNextButton = false;
            break;
        
      }
    } else {
      showNextButton = false;
    }
    var match$8 = state.currentPreview;
    var showSkipButton;
    if (match$8 !== undefined) {
      switch (match$8.TAG) {
        case "QuestionPage" :
            var q$3 = match$8._1;
            if (q$3.TAG === "SingleQuestion") {
              var question$2 = q$3._0;
              showSkipButton = question$2 !== undefined ? !Question$ReactHooksTemplate.mandatory(question$2) && !Question$ReactHooksTemplate.answered(question$2) : false;
            } else {
              var currentQuestions = q$3._0;
              var mandatoryQuestions = Belt_List.keep(currentQuestions, Question$ReactHooksTemplate.mandatory);
              var hasMandatoryQuestions = List.length(mandatoryQuestions) > 0;
              var answeredAnyQuestion = Belt_List.some(currentQuestions, (function (q) {
                      if (Question$ReactHooksTemplate.answered(q)) {
                        return Question$ReactHooksTemplate.isValidAnswer(q);
                      } else {
                        return false;
                      }
                    }));
              showSkipButton = !hasMandatoryQuestions && !answeredAnyQuestion;
            }
            break;
        case "Welcome" :
        case "ThankYou" :
            showSkipButton = false;
            break;
        
      }
    } else {
      showSkipButton = false;
    }
    return JsxRuntime.jsx(JsxRuntime.Fragment, {
                children: Caml_option.some(JsxRuntime.jsx(SurveyPreviewHtmlRenderer$ReactHooksTemplate.make, {
                          questions: state.embeddedLogic ? allQuestions(state.surveyNavigator) : SurveyNavigator$ReactHooksTemplate.questions(state.surveyNavigator),
                          survey: survey,
                          page: page,
                          logo: state.logo,
                          theme: state.theme,
                          client: state.client,
                          onNextButtonClick: onNextButtonClick,
                          onPrevButtonClick: onPrevButtonClick,
                          handleQuestionPreview: (function (y) {
                              Curry._1(dispatch, {
                                    TAG: "UpdateQuestion",
                                    _0: y
                                  });
                              var nps = Question$ReactHooksTemplate.questionType(y);
                              switch (nps.TAG) {
                                case "OpinionScale" :
                                    return autoAdvanceNextPage(OpinionScale$ReactHooksTemplate.answered(nps._0));
                                case "StarRating" :
                                    return autoAdvanceNextPage(StarRating$ReactHooksTemplate.answered(nps._0));
                                case "Nps" :
                                    return autoAdvanceNextPage(Nps$ReactHooksTemplate.answered(nps._0));
                                case "MultipleChoice" :
                                    return autoAdvanceNextPage(MultipleChoice$ReactHooksTemplate.answered(nps._0));
                                case "RatingGroup" :
                                    return autoAdvanceNextPage(RatingGroup$ReactHooksTemplate.answered(nps._0, y.mandatory));
                                case "SmileyRating" :
                                    return autoAdvanceNextPage(SmileyRating$ReactHooksTemplate.answered(nps._0));
                                case "Csat" :
                                    return autoAdvanceNextPage(Csat$ReactHooksTemplate.answered(nps._0));
                                case "MultipleSelect" :
                                    var multipleSelect = nps._0;
                                    return autoAdvanceNextPage(MultipleSelect$ReactHooksTemplate.multipleAnswer(multipleSelect) ? MultipleSelect$ReactHooksTemplate.maximumSelectionReached(multipleSelect) : MultipleSelect$ReactHooksTemplate.answered(multipleSelect));
                                case "DropDown" :
                                    return autoAdvanceNextPage(DropDown$ReactHooksTemplate.answered(nps._0));
                                default:
                                  return ;
                              }
                            }),
                          onLanguageChange: (function (e) {
                              var languageName = e.target.value;
                              var language = List.find((function (x) {
                                      return SurveyLanguage$ReactHooksTemplate.name(x) === languageName;
                                    }), state.surveyLanguages);
                              Curry._1(dispatch, {
                                    TAG: "ChangeLanguage",
                                    _0: language
                                  });
                            }),
                          handleStart: (function (param) {
                              Curry._1(dispatch, "PreviewQuestions");
                            }),
                          type_: type_,
                          showPreviousButton: showPreviousButton,
                          showNextButton: showNextButton,
                          showSkipButton: showSkipButton,
                          showSubmitButton: showSubmitButton,
                          languageSelected: state.language,
                          surveyLanguages: state.surveyLanguages,
                          redirectionDelay: survey.redirectionDelay,
                          verificationCode: state.verificationCode,
                          substitutionVariables: substitutionVariables
                        }))
              });
  };
  switch (match$2[0]) {
    case "Loading" :
        return JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                          text: "Loading Survey..."
                        }),
                    className: "h-screen w-full animated fadeIn"
                  });
    case "Ready" :
        if (preview) {
          return JsxRuntime.jsx(JsxRuntime.Fragment, {
                      children: Caml_option.some(surveyPreview("Modal"))
                    });
        } else {
          return JsxRuntime.jsx(JsxRuntime.Fragment, {
                      children: Caml_option.some(surveyPreview("Page"))
                    });
        }
    case "Saving" :
        return JsxRuntime.jsx("p", {
                    children: "Saving survey in progress..."
                  });
    case "Expired" :
        var logo = state.logo;
        return JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            logo !== undefined ? JsxRuntime.jsx("img", {
                                    className: "w-48 object-contain",
                                    src: logo
                                  }) : null,
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("h2", {
                                          children: "Survey Unavailable",
                                          className: "text-xl font-semibold text-gray-800"
                                        }),
                                    JsxRuntime.jsx("p", {
                                          children: "Oops! Thank you for trying to participate in the survey. You've already submitted your response or your session has expired.",
                                          className: "text-gray-600 text-sm leading-relaxed"
                                        })
                                  ],
                                  className: "text-center space-y-3"
                                })
                          ],
                          className: "flex flex-col items-center max-w-md w-full rounded-2xl shadow-lg p-8 gap-6"
                        }),
                    className: "min-h-screen flex items-center justify-center bg-gray-50 px-4"
                  });
    
  }
}

var yesbankQuestiontemplate = "\n  <div class=\"flex flex-col h-full min-h-screen\">\n    <div class=\"h-80-px small:h-60-px mb-10 small:mb-12\">\n      <div id=\"logo\">\n        logo\n      </div>\n    </div>\n    <div class=\"mx-12 small:mx-4 flex flex-col\">\n      <div class=\"pl-142-px small:pl-4 pr-80-px small:pr-4 pt-24 small:pt-4 question-box-gradient rounded-lg mb-8 overflow-y-auto pb-16\n    small:pb-12\" style=\"height: calc(100vh - 250px);\">\n        <div id=\"question\">question</div>\n      </div>\n    </div>\n\n    <div class=\"flex w-full justify-center items-center gap-4 small:mb-8 mb-4\">\n      <div id=\"previousButton\"></div>\n      <div id=\"nextButton\"></div>\n    </div>\n  </div>\n";

var make = SurveyView;

exports.yesbankQuestiontemplate = yesbankQuestiontemplate;
exports.defaultQuestiontemplate = defaultQuestiontemplate;
exports.bhimaQuestiontemplate = bhimaQuestiontemplate;
exports.questionTemplates = questionTemplates;
exports.questionsOrPageToString = questionsOrPageToString;
exports.surveyToJson = surveyToJson;
exports.addQuestionsToGraph = addQuestionsToGraph;
exports.surveyAnswers = surveyAnswers;
exports.calculateTotalPages = calculateTotalPages;
exports.getQuestionsForCurrentPage = getQuestionsForCurrentPage;
exports.getQuestionView = getQuestionView;
exports.getNextNode = getNextNode;
exports.getPreviousNode = getPreviousNode;
exports.findMatchingRedirectionUrlId = findMatchingRedirectionUrlId;
exports.submitQuestionResponses = submitQuestionResponses;
exports.allQuestions = allQuestions;
exports.allThankYous = allThankYous;
exports.isSinglePage = isSinglePage;
exports.reducer = reducer;
exports.defaultWelcome = defaultWelcome;
exports.defaultThankYou = defaultThankYou;
exports.defaultOpinionScale = defaultOpinionScale;
exports.defaultStarRating = defaultStarRating;
exports.defaultLongText = defaultLongText;
exports.defaultShortText = defaultShortText;
exports.saveForm = saveForm;
exports.make = make;
/* defaultThankYou Not a pure module */
